'use client';

import { resolveRoute } from "../helpers";
import { AppRoutes } from "../routes";
import { usePathname, useRouter } from 'next/navigation';

export default function Navigation() {
    const pathname = usePathname();
    const router = useRouter();

    const getBackgroundStyle = (routeName: string) => {
        return pathname === routeName ? 'bg-gray-200': 'hover:bg-gray-200';
    };

    const onRouteChoose = (routeName: string) => {
        router.push(routeName);
    };

    return (
        <nav className="w-1/4 bg-white shadow-lg rounded-lg p-4 border-r-4 border-gray-300">
            <h1 className="text-xl font-semibold mb-4">Navigation</h1>
            <ul>
                <li
                    className={`p-2 cursor-pointer rounded ${getBackgroundStyle(resolveRoute(AppRoutes.PatientsList))}`}
                    onClick={() => onRouteChoose(resolveRoute(AppRoutes.PatientsList))}
                >
                    Patients
                </li>
                <li
                    className={`p-2 cursor-pointer rounded mt-2 ${getBackgroundStyle(resolveRoute(AppRoutes.Adjudication))}`}
                    onClick={() => onRouteChoose(resolveRoute(AppRoutes.Adjudication))}
                >
                    Adjudication
                </li>
                <li
                    className={`p-2 cursor-pointer rounded mt-2 ${getBackgroundStyle(resolveRoute(AppRoutes.About))}`}
                    onClick={() => onRouteChoose(resolveRoute(AppRoutes.About))}
                >
                    About
                </li>
            </ul>
        </nav>
    );
}
